import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { EXTERNAL_FILE_STORAGE_REPOSITORY } from '../../core';
import { EXTERNAL_FILE_STORAGE_API } from '../data-sources';
import { mappingResultError, Result } from '@digibricks/core';
export var ExternalFileStorageRepository = /*#__PURE__*/function () {
  function ExternalFileStorageRepository(externalFileStorageApi) {
    _classCallCheck(this, ExternalFileStorageRepository);

    this.externalFileStorageApi = externalFileStorageApi;
  }

  _createClass(ExternalFileStorageRepository, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input, url) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.externalFileStorageApi.create(input, url);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create(_x, _x2) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return ExternalFileStorageRepository;
}();
export var externalFileStorageRepositoryProvider = {
  provide: EXTERNAL_FILE_STORAGE_REPOSITORY,
  useFactory: function useFactory(externalFileStorageApi) {
    return new ExternalFileStorageRepository(externalFileStorageApi);
  },
  inject: [EXTERNAL_FILE_STORAGE_API]
};